module.exports = __webpack_public_path__ + "img/stoplights-fill.03c11e93.svg";